import React from "react";

// import Car from "../../Assets/Img/car.png";
// import Customer from "../../Assets/Img/customer.png";
// import Note from "../../Assets/Img/note.png";
// import Discount from "../../Assets/Img/discount.png";

import formalin from "../../Assets/Img/specimen.png";
import tasty from "../../Assets/Img/full.png";
import delevary from "../../Assets/Img/express-delivery.png";
import payment from "../../Assets/Img/credit-card.png";
const Service = () => {
  return (
    <>
      <div id="Service" className="d-none d-sm-block">
        <div className="container">
          <div className="ServiceCard card">
            <div className="ServiceCardBody row card-body">
              <div className=" col-6 col-md-3  border-secondary">
                <div className="ServiceCardItem  flex-sm-row d-flex justify-content-between align-items-center ">
                  <div className="image">
                    <img width="100%" src={formalin} className="img-fluid" />
                  </div>
                  <h4 className="ServiceTitle">ফর্মালিন মুক্ত আম!</h4>
                </div>
              </div>
              <div className=" col-6 col-md-3  border-secondary">
                <div className="ServiceCardItem d-flex  flex-sm-row justify-content-between align-items-center ">
                  <div className="image">
                    <img width="100%" src={tasty} className="img-fluid" />
                  </div>
                  <h4 className="ServiceTitle">আসল জাত, আসল স্বাদ!</h4>
                </div>
              </div>
              <div className="col-6 col-md-3 border-secondary">
                  <div className="ServiceCardItem  flex-sm-row d-flex justify-content-between align-items-center">
                    <div className="image">
                      <img src={payment} className="img-fluid" />
                    </div>
                    <h4 className="ServiceTitle">সহজ ও সেইফ পেমেন্ট</h4>
                  </div>
                </div>
                 <div className="col-6 col-md-3 border-secondary">
                  <div
                    style={{ border: "none" }}
                    className="ServiceCardItem flex-sm-row d-flex justify-content-between align-items-center"
                  >
                    <div className="image">
                      <img src={delevary} className="img-fluid" />
                    </div>
                    <h4 className="ServiceTitle">দ্রুত ডেলিভারি!</h4>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Service;
